import { IMultiSelectSidebarStore, MultiSelectSidebarMode } from './multiSelectSidebar.interface';

export const multiSelectSidebarInitialState: IMultiSelectSidebarStore = {
  isMultiEditMode: false,
  selectedIds: [],
  selectedRows: [],
  mode: MultiSelectSidebarMode.None,
};
